const dashboardGridlets = angular.module('dashboardGridletDirectives', []);

dashboardGridlets.directive('trainStatusGridletModule', function(
  fleetService,
  $translate,
  $timeout
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/train-status-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
    },
    link: function(scope) {
      scope.$on('gridlet-init', function() {
        scope.$broadcast('reflow');
      });

      scope.$on('gridlet-refresh', function() {
        scope.$broadcast('reflow');
      });

      scope.$watch('settings.fullscreen', function() {
        scope.dataLoading = true;
        scope.loadGraph();
      });

      let lastLoad = DateTime.now();
      scope.$on('gridlet-update-data', function(e) {
        if (lastLoad.diffNow('seconds').seconds < -3) {
          scope.loadGraph();
        }
      });

      scope.config = {
        chart: {
          type: 'pie',
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.y}',
            },
          },
          pie: {
            point: {
              events: {
                legendItemClick: function() {
                  return false;
                },
              },
            },
          },
        },
        legend: {
          itemStyle:
          {
            fontSize: "18px",
          },
          itemHoverStyle: {
            cursor: 'default',
          },
        },
        series: [],
      };

      scope.loadGraph = function() {
        fleetService
          .getStatusGraph()
          .then(function(data) {
            lastLoad = DateTime.now();
            // J126-148 Order Fleet Status graph legend items in the same order as in Fleet Info & Train Overview
            const legendOrder = ['ALARM', 'FAULT', 'OK', 'OFFLINE'];
            if (!angular.equals(scope.config.series, data)) {
              const orderedData = [];
              orderedData.push({
                id: data[0].id,
                name: $translate.instant('dashboard.status-gridlet-module.series-name'),
                type: data[0].type,
                count: data[0].count,
                data: []
              });
              legendOrder.forEach(legendItem => {
                const item = data[0].data.find(item => item.name.toUpperCase() === legendItem);
                item.name = $translate.instant('dashboard.status-gridlet-module.' + item.name);
                orderedData[0].data.push(item);
              });
              scope.config.series = orderedData;
              $timeout(function() {
                scope.dataLoading = false;
                scope.$broadcast('reflow');
              }, 1000);
            }
            data = null;
          });
      };
      scope.dataLoading = true;
      scope.loadGraph();
    },
  };
});

dashboardGridlets.directive('fleetGridletModule', function(
  $state,
  fleetService,
  $translate,
  ConditionService,
  $timeout,
  __env
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/fleet-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.sortType = 'status';
      scope.sortSubType = 'events';
      scope.sortReverse = true;
      scope.search = '';
      scope.__env = __env;

      const contentAreaId = 'div#fleetListContainer';
      const area = '#gridletContentArea-fleet-gridlet';

      scope.setSortType = function(column) {
        if (scope.sortType === column) {
          scope.sortReverse = !scope.sortReverse;
        } else {
          scope.sortType = column;
          scope.sortReverse = column === 'status' || column === 'dataReceived';
        }
      };

      function adjustContentSize(selectorId, contentAreaSelectorId) {
        $timeout(function() {
          const selectorIdHeight = $(selectorId).height();
          if (selectorIdHeight > 100) {
            // IE hack
            $(contentAreaSelectorId).height(selectorIdHeight - 40);
          }
          if (scope.settings.fullscreen) {
            const gridletFullscreenControleArea = $(
              '.gridletFullscreenControleArea'
            ).height();
            $(contentAreaSelectorId).height(
              selectorIdHeight - 93 - gridletFullscreenControleArea
            );
          }
          scope.areaWidth = $(contentAreaSelectorId).width();
          // $("div.notificationTitleContainer").width(scope.areaWidth);
        }, 200);
      }

      $(window).resize(function() {
        if (scope.area) {
          adjustContentSize(area, contentAreaId);
        }
      });

      scope.scrollElementTop = function(element) {
        if (element) {
          $(element).animate({ scrollTop: 0 }, 'fast');
        }
      };

      scope.$watch('settings.fullscreen', function() {
        $timeout(function() {
          scope.search = '';
          scope.loadTrains();
        }, 400);
      });

      let lastLoad = DateTime.now();
      scope.$on('gridlet-update-data', function(e) {
        if (lastLoad.diffNow('seconds').seconds < -3) {
          scope.loadTrains();
        }
      });

      function createExportCriteria() {
        return {
          userFilterType: 'ALL', // removed, old alarms functionality
          userSectorId: null, // removed, old alarms functionality
          sortType: scope.sortType.toUpperCase(),
          sortSubType: scope.sortSubType.toUpperCase(),
          sortReverse: scope.sortReverse,
        };
      }

      scope.exportToExcel = function() {
        fleetService.exportToExcel(
          createExportCriteria(),
          $translate.instant('export.fleet-status')
        );
      };

      scope.exportToCsv = function() {
        fleetService.exportToCsv(
          createExportCriteria(),
          $translate.instant('export.fleet-status')
        );
      };

      if (__env.profile === 'VR') {
        scope.$emit('gridlet-register-export', {
          excel: scope.exportToExcel,
          csv: scope.exportToCsv,
        });
      }

      scope.loadTrains = function() {
        if (__env.profile === 'VR') {
          ConditionService
              .getFleetData()
              .then(function(data) {
                adjustContentSize(area, contentAreaId);
                scope.fleet = angular.copy(data);
                data = null;
                scope.dataLoading = false;
              });
        } else {
          fleetService
            .getAll()
            .then(function (data) {
              adjustContentSize(area, contentAreaId);
              scope.fleet = angular.copy(data);
              data = null;
              scope.dataLoading = false;
            });
        }
        lastLoad = DateTime.now();
      };

      scope.goToTrainPage = function(event) {
        $state.go('train', { consist: event.trainItem.trainId });
      };

      function init() {
        scope.dataLoading = true;
        scope.loadTrains();
      }

      init();
    },
  };
});

dashboardGridlets.directive('notificationGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/notification-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-notification-gridlet';
      scope.gridlet = 'notification-gridlet';

      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'activated',
          label: 'dashboard.notification-gridlet-module.activated-filter',
        },
        {
          name: 'deactivated',
          label: 'dashboard.notification-gridlet-module.deactivated-filter',
        },
        {
          name: 'ack',
          label: 'dashboard.notification-gridlet-module.ack-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
        {
          name: 'deactive',
          label: 'dashboard.notification-gridlet-module.show-deactivated',
        },
      ];

      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };

      scope.criteria = {
        skipAmount: 0,
        count: 15,
        sortType: 'ACTIVATED',
        reverse: true,
        searchString: '',
        filter: {}, // removed, old alarms functionality
        searchChanged: false,
      };
    },
  };
});

dashboardGridlets.directive('newFleetInfoGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/new-fleet-info-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-new-fleet-info-gridlet';
      scope.gridlet = 'new-fleet-info-gridlet';
    },
  };
});

dashboardGridlets.directive('fleetListGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/fleet-list-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-fleet-list-gridlet';
      scope.gridlet = 'fleet-list-gridlet';
    },
  };
});


dashboardGridlets.directive('carListGridletValeModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/car-list-gridlet-vale-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-car-list-gridlet-vale';
      scope.gridlet = 'car-list-gridlet-vale';
    },
  };
});

dashboardGridlets.directive('trainSoftwareStatusModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/train-software-status-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-train-software-status';
      scope.gridlet = 'train-software-status';
    },
  };
});

dashboardGridlets.directive('activeEventsGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/active-events-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-active-events-gridlet';
      scope.gridlet = 'active-events-gridlet';
    },
  };
});

dashboardGridlets.directive('historyEventsGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/history-events-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-history-events-gridlet';
      scope.gridlet = 'history-events-gridlet';
      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'activated',
          label: 'dashboard.notification-gridlet-module.activated-filter',
        },
        {
          name: 'deactivated',
          label: 'dashboard.notification-gridlet-module.deactivated-filter',
        },
        {
          name: 'ack',
          label: 'dashboard.notification-gridlet-module.ack-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
        {
          name: 'deactive',
          label: 'dashboard.notification-gridlet-module.show-deactivated',
        },
      ];
      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };
      scope.criteria = {
        count: 15,
        eventSortType: 'ACTIVATED',
        sortReverse: true,
        searchString: '',
        searchChanged: false,
      };
    },
  };
});

dashboardGridlets.directive('auditEventsGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/audit-events-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-audit-events-gridlet';
      scope.gridlet = 'audit-events-gridlet';
      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'activated',
          label: 'dashboard.notification-gridlet-module.activated-filter',
        },
        {
          name: 'deactivated',
          label: 'dashboard.notification-gridlet-module.deactivated-filter',
        },
        {
          name: 'ack',
          label: 'dashboard.notification-gridlet-module.ack-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
        {
          name: 'deactive',
          label: 'dashboard.notification-gridlet-module.show-deactivated',
        },
      ];
      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };
      scope.criteria = {
        count: 15,
        eventSortType: 'ACTIVATED',
        sortReverse: true,
        searchString: '',
        searchChanged: false,
      };
    },
  };
});

dashboardGridlets.directive('activeEventsListGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/active-events-list-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-active-events-list-gridlet';
      scope.gridlet = 'active-events-list-gridlet';
      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
      ];
      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };
      scope.criteria = {
        count: 15,
        eventSortType: 'ACTIVATED',
        sortReverse: true,
        searchString: '',
        searchChanged: false,
      };
    },
  };
});

dashboardGridlets.directive('systemStatusGridletModule', function(
  systemStatusService,
  $timeout
) {
  return {
    replace: true,
    restrict: 'E',
    templateUrl:
      '/modules/gridlets/dashboard/system-status-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
    },
    link: function(scope) {
      let lastLoad;
      const contentAreaId = 'div#systemStatusGridlet';

      scope.$watch('settings.fullscreen', function() {
        $timeout((scope.isSmallFont = $(contentAreaId).width() < 250), 500);
      });

      $(window).resize(function() {
        scope.isSmallFont = $(contentAreaId).width() < 250;
      });

      scope.$on('gridlet-update-data', function(e) {
        if (lastLoad.diffNow('seconds').seconds < -5) {
          scope.loadStatus();
        }
      });

      scope.getTrainBoxStatus = function() {
        return scope.status.onlineTrains / scope.status.totalTrains;
      };

      scope.loadStatus = function() {
        $timeout.cancel(scope.loadTimeoutPromise);
        lastLoad = DateTime.now();
        systemStatusService.getSystemStatus().then(function(data) {
          if (!angular.equals(scope.status, data)) {
            scope.status = data;
          }
          data = null;
          scope.isSmallFont = $(contentAreaId).width() < 250;
        });
        scope.loadTimeoutPromise = $timeout(scope.loadStatus, 7000);
      };

      scope.$on('$destroy', function() {
        $timeout.cancel(scope.loadTimeoutPromise);
      });

      lastLoad = DateTime.now();

      function init() {
        scope.isSmallFont = false;

        scope.status = {
          usersOnline: 0,
          totalUsers: 0,
          onlineMoc: 0,
          onlineOcc: 0,
          onlineTrains: 0,
          totalTrains: 0,
          wifiTrains: 0,
          mobileTrains: 0,
          offlineTrains: 0,
        };

        scope.loadStatus();
        $timeout((scope.isSmallFont = $(contentAreaId).width() < 250), 500);
      }

      init();
    },
  };
});

dashboardGridlets.directive('conditionAlertListGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/condition-alert-list-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-active-events-list-gridlet';
      scope.gridlet = 'active-events-list-gridlet';
      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
      ];
      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };
      scope.criteria = {
        skipAmount: 0,
        count: 15,
        sortType: 'ACTIVATED',
        reverse: true,
        searchString: '',
        filter: {}, // removed, old alarms functionality
        searchChanged: false,
      };
    },
  };
});

dashboardGridlets.directive('conditionEventListGridletModule', function() {
  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/dashboard/condition-event-list-gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      filter: '=',
    },
    link: function(scope) {
      scope.area = '#gridletContentArea-condition-event-list-gridlet';
      scope.gridlet = 'condition-event-list-gridlet';
      scope.filterList = [
        {
          name: 'train',
          label: 'dashboard.notification-gridlet-module.train-filter',
        },
        {
          name: 'car',
          label: 'dashboard.notification-gridlet-module.car-filter',
        },
        {
          name: 'eventId',
          label: 'dashboard.notification-gridlet-module.event-filter',
        },
        {
          name: 'name',
          label: 'dashboard.notification-gridlet-module.name-filter',
        },
      ];
      scope.selection = {
        values: {
          train: true,
          car: true,
          eventId: true,
          activated: true,
          deactivated: true,
          ack: true,
          name: true,
          deactive: false,
        },
      };
      scope.criteria = {
        skipAmount: 0,
        count: 15,
        sortType: 'ACTIVATED',
        reverse: true,
        searchString: '',
        filter: {}, // removed, old alarms functionality
        searchChanged: false,
      };
    },
  };
});
